__turbopack_context__.v({
  "cover": "Cover-module__MGFKJq__cover",
  "ctaWrapper": "Cover-module__MGFKJq__ctaWrapper",
  "descriptionWrapper": "Cover-module__MGFKJq__descriptionWrapper",
  "desktopFormWrapper": "Cover-module__MGFKJq__desktopFormWrapper",
  "familyLogoWrapper": "Cover-module__MGFKJq__familyLogoWrapper",
  "fromDestinationNotAvailableButton": "Cover-module__MGFKJq__fromDestinationNotAvailableButton",
  "heading": "Cover-module__MGFKJq__heading",
  "information": "Cover-module__MGFKJq__information",
  "informationWrapper": "Cover-module__MGFKJq__informationWrapper",
  "label": "Cover-module__MGFKJq__label",
  "layout": "Cover-module__MGFKJq__layout",
  "mobileOnly": "Cover-module__MGFKJq__mobileOnly",
  "row": "Cover-module__MGFKJq__row",
});
